<div class="vmware-table-container">
	<dl-table-viz [columns]="columns" resourceName="getVmWareDatastore"></dl-table-viz>
</div>
